export enum CustomerContactType {
  LEGAL_REPRESENTATIVE = 'LEGAL_REPRESENTATIVE',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  ACCOUNTANT = 'ACCOUNTANT',
  MANDATEE = 'MANDATEE',
  OTHER = 'OTHER',

}
